export default "__VITE_ASSET__oFN1hGdJ__";